import React from 'react';
import { TableTreeExpand } from '../../model';
import { renderIconDownRight } from './func';

interface IProps {
  readonly children: React.ReactNode;
  readonly expandTree?: TableTreeExpand;
  readonly id: string;
  readonly onChangeTreeExpand: (id: string, status: boolean) => void;
  readonly renderIconDown?: (isExpand: boolean) => React.ReactNode;
}

export const TreeOperatePackage = (props: IProps) => {
  const { id } = props;
  const isExpand = props.expandTree ? props.expandTree[id] : false;

  const onTreeExpand = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    props.onChangeTreeExpand(id, !isExpand);
  };

  const renderIcon =
    typeof props?.renderIconDown === 'function'
      ? props.renderIconDown
      : renderIconDownRight;
  return (
    <div className="webkit-box td-btn-render" id={`id-${id}`}>
      <div className="tree-icon pointer-all" onClick={onTreeExpand}>
        {renderIcon(isExpand)}
      </div>
      {props.children}
    </div>
  );
};
